import * as React from 'react';
import { times } from 'ramda';
import { TeamMembersContainer, TeamMember } from './components';
import { useLocalizedSanityTeamMembers } from '../../../../sanity';

const loadingIds = times((i) => ({ _id: `loading${i}` }), 16);

export const TeamMembers = () => {
  const {
    data,
  } = useLocalizedSanityTeamMembers();
  return (
    <TeamMembersContainer>
      {(data ?? loadingIds).map(({ _id }) => <TeamMember key={_id} id={_id} />)}
    </TeamMembersContainer>
  );
};
